import axios from 'axios';
import config from '../config/config';
import { getAuthToken } from '../utils/token';

const getAuthConfig = () => {

    const token = getAuthToken();

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };
};

/**
 * Get all Printing Process records
 */
export const getPrintingProcesses = async (params = {}) => {

    return axios.get(
        `${config.API}/printingprocess/index`,
        {
            ...getAuthConfig(),
            params
        }
    );
};

/**
 * Get single Printing Process
 */
export const getPrintingProcess = async (id) => {

    return axios.get(
        `${config.API}/printingprocess/${id}`,
        getAuthConfig()
    );
};

/**
 * Create Printing Process
 */
export const createPrintingProcess = async (data) => {

    return axios.post(
        `${config.API}/printingprocess/create`,
        data,
        getAuthConfig()
    );
};

/**
 * Update Printing Process
 */
export const updatePrintingProcess = async (id, data) => {

    return axios.put(
        `${config.API}/printingprocess/update/${id}`,
        data,
        getAuthConfig()
    );
};

/**
 * Delete Printing Process
 */
export const deletePrintingProcess = async (id) => {

    return axios.delete(
        `${config.API}/printingprocess/delete/${id}`,
        getAuthConfig()
    );
};